/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste X, Y and size values to build a bubble chart — a scatter plot where each point's area encodes a third variable. Each row is one bubble: x, y, then size.`)
};

const es_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega valores X, Y y de tamaño para crear un gráfico de burbujas — un diagrama de dispersión donde el área de cada punto codifica una tercera variable. Cada fila es una burbuja: x, y, luego tamaño.`)
};

const de_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie X-, Y- und Größenwerte ein, um ein Blasendiagramm zu erstellen — ein Streudiagramm, bei dem die Fläche jedes Punktes eine dritte Variable kodiert. Jede Zeile ist eine Blase: x, y, dann Größe.`)
};

const nl_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak X-, Y- en grootte-waarden om een bellendiagram te bouwen — een spreidingsdiagram waarbij het oppervlak van elk punt een derde variabele codeert. Elke rij is één bel: x, y, dan grootte.`)
};

const fr_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez des valeurs X, Y et taille pour créer un graphique à bulles — un nuage de points où l'aire de chaque point encode une troisième variable. Chaque ligne est une bulle : x, y, puis taille.`)
};

const it_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla valori X, Y e dimensione per costruire un grafico a bolle — un grafico a dispersione dove l'area di ciascun punto codifica una terza variabile. Ogni riga è una bolla: x, y, poi dimensione.`)
};

const pt_br2_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole valores de X, Y e tamanho para criar um gráfico de bolhas — um gráfico de dispersão em que a área de cada ponto codifica uma terceira variável. Cada linha é uma bolha: x, y, depois tamanho.`)
};

const pt_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole valores de X, Y e tamanho para construir um gráfico de bolhas — um gráfico de dispersão onde a área de cada ponto codifica uma terceira variável. Cada linha é uma bolha: x, y, e depois o tamanho.`)
};

const ja_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X、Y、サイズの値を貼り付けるとバブルチャートが作成されます — 各点の面積が3つ目の変数を表す散布図です。1行が1つのバブルで、x、y、サイズの順です。`)
};

const zh_bubble_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 X、Y 和大小数值以构建气泡图——一种每个点的面积代表第三个变量的散点图。每行代表一个气泡：x、y，然后是大小。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_intro", locale)
	if (locale === "en") return en_bubble_intro(inputs)
	if (locale === "es") return es_bubble_intro(inputs)
	if (locale === "de") return de_bubble_intro(inputs)
	if (locale === "nl") return nl_bubble_intro(inputs)
	if (locale === "fr") return fr_bubble_intro(inputs)
	if (locale === "it") return it_bubble_intro(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_intro(inputs)
	if (locale === "pt") return pt_bubble_intro(inputs)
	if (locale === "ja") return ja_bubble_intro(inputs)
	return zh_bubble_intro(inputs)
};